<static-hdr></static-hdr>

<section class="container my-10" [@routerTransition]> <!-- Main Container -->

    <!-- Top Section: Breadcrumbs and Title -->
    <div class="row mb-5">
        <div class="col-12 d-flex justify-content-between align-items-center">

            <!-- Title -->
            <h1 class="font-weight-bold text-dark display-4">مركز المعرفة</h1>

            <!-- Breadcrumbs -->
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent px-0 mb-0">
                    <li class="breadcrumb-item"><a [routerLink]="['/home']" class="text-muted">
                            المركز السعودي لكفائة الطاقة
                        </a>
                    </li>
                    <li class="breadcrumb-item"><a href="javascript:;" class="text-muted">المركز الإعلامي</a></li>
                    <li class="breadcrumb-item active text-primary font-weight-bold" aria-current="page">مركز المعرفة
                    </li>
                </ol>
            </nav>
        </div>
    </div>

    <!-- Content Section -->
    <div class="row">
        <div class="col-12">

            <!-- Section Header: 'All' + Search + Category -->
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <h2 class="font-weight-bold display-5">جميع المعلومات</h2>

                <div class="d-flex align-items-center gap-3 flex-wrap mt-3 mt-md-0">
                    <!-- Category Select -->
                    <div style="min-width: 200px;margin-left: 4px;">
                        <select class="form-control" [(ngModel)]="selectedCategory" (change)="onCategoryChange()"
                            style="border-radius: 10px; height: 45px; border-color: #e0e6ed;">
                            <option [ngValue]="undefined">كل التصنيفات</option>
                            <option *ngFor="let cat of categories" [ngValue]="cat.value">{{ cat.label }}</option>
                        </select>
                    </div>

                    <!-- Search Box (News style) -->
                    <div class="search-box" style="min-width: 300px;">
                        <div class="input-group search--btn">
                            <input type="text" class="form-control" [class.is-invalid]="showValidationMessage"
                                placeholder="بحث في العنوان أو الوصف..." [(ngModel)]="filterText"
                                (keyup.enter)="onSearch()">
                            <span class="input-group-text" style="cursor:pointer;" (click)="onSearch()">
                                <i class="fa fa-search text-muted"></i>
                            </span>
                            <span *ngIf="filterText" class="input-group-text bg-white border-right-0"
                                style="cursor:pointer; border-left:none;" (click)="filterText=''; onSearch()"
                                title="مسح البحث">
                                <i class="fa fa-times text-muted"></i>
                            </span>
                        </div>
                        <small *ngIf="showValidationMessage" class="text-danger d-block mt-1">
                            <i class="fa fa-exclamation-circle ml-1"></i>
                            من فضلك أدخل 3 أحرف على الأقل
                        </small>
                    </div>
                </div>
            </div>

            <div class="mb-4"></div>

            <!-- Loading Spinner -->
            <div *ngIf="loading" class="kb-loading">
                <div class="kb-spinner"></div>
            </div>

            <!-- Cards Grid -->
            <div *ngIf="!loading" class="kb-grid">
                <div *ngIf="items?.length === 0" class="kb-empty">
                    <div class="kb-empty-content">
                        <i class="fas fa-search-minus mb-4"></i>
                        <p>لا توجد نتائج مطابقة </p>
                        <button class="btn btn-link"
                            (click)="filterText=''; selectedCategory=undefined; loadItems()">إعادة تعيين </button>
                    </div>
                </div>

                <div class="kb-card" *ngFor="let item of items">
                    <div class="kb-card-header">
                        <div class="kb-card-icon">
                            <i class="fas fa-file-alt"></i>
                        </div>
                        <span class="kb-category-badge" [ngClass]="'cat-' + item.knowledgeBank?.category">
                            {{ getCategoryLabel(item.knowledgeBank?.category) }}
                        </span>
                    </div>

                    <h3 class="kb-card-title">{{ item.knowledgeBank?.title }}</h3>
                    <p class="kb-card-desc">{{truncateTwoSentences(item.knowledgeBank?.description)}}</p>

                    <div class="kb-card-footer mt-auto">
                        <div class="kb-card-date">
                            <i class="far fa-calendar-alt"></i>
                            {{ item.knowledgeBank?.creationTime | date:'dd/MM/yyyy' }}
                        </div>
                        <button class="kb-card-btn" (click)="viewDetails(item.knowledgeBank?.id)">
                            عرض المزيد
                        </button>
                    </div>
                </div>
            </div>

            <!-- Pagination -->
            <div *ngIf="!loading && totalCount > 0" class="kb-pagination" dir="ltr">
                <button class="kb-page-btn kb-page-nav" [disabled]="currentPage === 0" (click)="prevPage()">
                    <i class="fas fa-chevron-left"></i>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button *ngIf="page !== '...'" class="kb-page-btn" [class.kb-page-active]="page === currentPage"
                        (click)="goToPage(page)">
                        {{ +page + 1 }}
                    </button>
                    <span *ngIf="page === '...'" class="kb-page-dots">···</span>
                </ng-container>

                <button class="kb-page-btn kb-page-nav" [disabled]="currentPage === totalPages - 1"
                    (click)="nextPage()">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>

        </div>
    </div>

</section>

<static-ftr></static-ftr>